import { useEffect } from 'react'

export const API_DOCUMENTATION_URL = 'https://merchjar.com/api/'

export const LegacyApiDocumentationRedirect = (): null => {
    useEffect(() => {
        window.location.replace(API_DOCUMENTATION_URL)
    }, [])

    return null
}
